module.exports = __webpack_public_path__ + "static/media/welcome.93cd8018.png";